import * as React from "react";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import Divider from "@mui/material/Divider";
import { AtomizerJobAPI, getVerifiedDocs } from '../../API/api';
import { toast } from "react-toastify";
import { MoreOutlined } from "@ant-design/icons";

export default function OptionMenu({ data, onChanges }) {
   const successMsg = (message) => {
      return (
        <>
          <span style={{ fontSize: "12px" }}>{message}</span>
        </>
      );
    };

  const emailQaPair=[
    {

    }
  ]

  const nonPublishOptions = [
    // { val: "Preview", id: "1", isShow: false },
    { val: "Update Content", id: "2", isShow: false },
    { val: "Publish", id: "4", isShow: false },
    // { val: "Linked QA", id: "6", isShow: false },
    { val: "Delete", id: "8", isShow: false },
    { val: "Generate Q's", id: "9", isShow: false },
  ];
  const nonPublishOptionsurlCrawl = [
    { val: "Update Content", id: "2", isShow: false },
    { val: "Publish", id: "4", isShow: false },
    { val: "Delete", id: "8", isShow: false },
    { val: "Generate Q's", id: "9", isShow: false },
  ];
  const nonPublishOptionsThread = [
    { val: "Update Content", id: "22", isShow: false },
    { val: "Publish", id: "4", isShow: false },
    { val: "Delete", id: "8", isShow: false },
  ];
  const publishOptionsThread = [
    { val: "Review Content", id: "23", isShow: false },
    { val: "Unpublish", id: "5", isShow: false },
    { val: `Publish As ${data.usageAccess !=='internal'?'Internal':'Public'}`, id: "7", isShow: false },
    { val: "Delete", id: "8", isShow: false },
  ];
  const nonPublishOptionsWithNewVersion = [
    // { val: "Preview", id: "1", isShow: false },
    { val: "Update Content", id: "2", isShow: false },
    { val: "Publish", id: "4", isShow: false },
    // { val: "Linked QA", id: "6", isShow: false },
    { val: "Delete", id: "8", isShow: false },
    { val: "Generate Q's", id: "9", isShow: false },
    { val: "New Version", id: "10", isShow: false },
    // { val: "Preview", id: "11", isShow: false },
    { val: "Update Content", id: "12", isShow: false },
    { val: "Overwrite", id: "13", isShow: false },
    { val: "Revert", id: "14", isShow: false },
  ];
  const publishOptions = [
    { val: "Review Content", id: "3", isShow: false },
    { val: "Unpublish", id: "5", isShow: false },
    // { val: "Linked QA", id: "6", isShow: false },
    { val: `Publish As ${data.usageAccess !=='internal'?'Internal':'Public'}`, id: "7", isShow: false },
    { val: "Delete", id: "8", isShow: false },
    { val: "Generate Q's", id: "9", isShow: false },
  ];
  const publishOptionsUrlCrawl = [
    { val: "Review Content", id: "3", isShow: false },
    { val: "Unpublish", id: "5", isShow: false },
    { val: `Publish As ${data.usageAccess !=='internal'?'Internal':'Public'}`, id: "7", isShow: false },
    { val: "Delete", id: "8", isShow: false },
    { val: "Generate Q's", id: "9", isShow: false },
  ];
  const publishOptionsWithNewVersion = [
    { val: "Review Content", id: "3", isShow: false },
    { val: "Unpublish", id: "5", isShow: false },
    // { val: "Linked QA", id: "6", isShow: false },
    { val: `Publish As ${data.usageAccess !=='internal'?'Internal':'Public'}`, id: "7", isShow: false },
    { val: "Delete", id: "8", isShow: false },
    { val: "Generate Q's", id: "9", isShow: false },
    { val: "New Version", id: "10", isShow: false },
    // { val: "Preview", id: "11", isShow: false },
    { val: "Update Content", id: "12", isShow: false },
    { val: "Overwrite", id: "13", isShow: false },
    { val: "Revert", id: "14", isShow: false },
  ];
  
  const correctOptions = (data) => {
    if (data.source === "Thread") {
      if (data.indexed) {
        return publishOptionsThread;
      } else {
        return nonPublishOptionsThread;
      }
    } else {
      if (data.docType === "urlcrawl") {
        if (data.indexed) {
          return publishOptionsUrlCrawl;
        } else {
          return nonPublishOptionsurlCrawl;
        }
      } else {
        if (data.newSoId === null) {
          if (data.indexed) {
            return publishOptions;
          } else {
            return nonPublishOptions;
          }
        } else {
          if (data.indexed) {
            return publishOptionsWithNewVersion;
          } else {
            return nonPublishOptionsWithNewVersion;
          }
        }
      }
    }
  };
  // correctOptions(data);
  const dispatch = useDispatch();
  const {isDrawerOpen, DrawerAction, DrawerPayload,DrawerPropData, ingestedSelectedData, advanceFilterModalToggle} = bindActionCreators(Actions, dispatch);
  const [options, setOptions] = React.useState(correctOptions(data));
  const [anchorEl, setAnchorEl] = React.useState(null);
  const   open = Boolean(anchorEl);
  const handleClick = (event) => {
    setOptions(correctOptions(data))
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const onCallApi = (payload)=>{
    handleClose();
    AtomizerJobAPI(payload).then(res=>{
      if (res===undefined) return;
      onChanges();
      if(res.data.success){
        toast.success(successMsg(res.data.message));

      }
    })
  }
  const onClickOptions = (key) => {
    if(key === '14'){
      let payload = {
        action: "revert",
        data: [
            {
                "jobId": data.jobid,
                "soId": data.newSoId,
            }
        ]
    }
    onCallApi(payload);
      // console.log("revert", data,payload);
    }
    if(key === '13'){
      ingestedSelectedData(data);
      advanceFilterModalToggle({ bool: true, value: "overwriteDoc" });
      handleClose();
    }
    if(key === "4"){
      ingestedSelectedData(data);
      advanceFilterModalToggle({ bool: true, value: "publishDoc" });
      handleClose();
    }
    if(key === "5"){
      let payload = {
        action: "unpublish",
        data: [
            {
                "jobId": data.docType==='Thread'?data.jobid:"",
                "soId": data.docType==='Thread'?"":data.soId,
                "thread": data.docType==='Thread'?true:false
            }
        ]
    }
    onCallApi(payload);
    }
    if(key === '9'){
      ingestedSelectedData(data);
      advanceFilterModalToggle({ bool: true, value: "generateQ" });
      handleClose();
    }
    if(key === '22' || key ==='23'){
      let payload = {
        action: "",
        data: [
          {
            jobId: "",
            soId: "",
            thread: false,
            page: null,
          },
        ],
      };
      DrawerAction('threadreview');
      payload.action = 'review';
      payload.data[0].thread = true
      payload.data[0].soId = "";
      payload.data[0].jobId = data.jobid;
      DrawerPayload(payload);
      DrawerPropData(data)
      isDrawerOpen(true)
      handleClose();
    }
    if(key === "7"){
      let payload = {
        action: "publish",
        usageAccess: data.usageAccess !=='internal'?'internal':'public',
        data: [
            {
              "jobId": data.docType==='Thread'?data.jobid:"",
              "soId": data.docType==='Thread'?"":data.soId,
              "thread": data.docType==='Thread'?true:false
            }
        ]
    }
    onCallApi(payload);
    }
    if(key === "8"){
      ingestedSelectedData(data);
      advanceFilterModalToggle({ bool: true, value: "deleteDoc" });
      handleClose();
    }
    if(key === "6"){
      getVerifiedDocs(data.soId).then(res=>{
        if (res===undefined) return;
        if(res.data.success && res.data.data.length === 0){
          toast.warning(successMsg('No linked QA available!'));
        }
        if(res.data.success && res.data.data.length > 0){
          toast.success(successMsg(res.data.message));
        }
      })
      handleClose();
    }
    if(key === '2' || key === '3'){
      let payload = {
        action: "",
        data: [
          {
            jobId: "",
            soId: "",
            thread: false,
            page: null,
          },
        ],
      };
      DrawerAction('review');
      payload.action = 'review';
      payload.data[0].thread = data.docType === 'Thread'?true:false;
      payload.data[0].soId = data.docType === 'Thread'?"":data.soId;
      payload.data[0].jobId = data.docType === 'Thread'?data.jobid:"";
      DrawerPayload(payload);
      DrawerPropData(data)
      isDrawerOpen(true)
      handleClose();
    }
    if(key === '12'){
      let payload = {
        action: "",
        data: [
          {
            jobId: "",
            soId: "",
            thread: false,
            page: null,
          },
        ],
      };
      DrawerAction('newversionreview');
      payload.action = 'review';
      payload.data[0].thread = data.docType === 'Thread'?true:false;
      payload.data[0].soId = data.docType === 'Thread'?"":data.newSoId;
      payload.data[0].jobId = data.docType === 'Thread'?data.jobid:"";
      DrawerPayload(payload);
      DrawerPropData(data)
      isDrawerOpen(true)
      handleClose();
    }
  };
  return (
    <div>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? "long-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreOutlined />
      </IconButton>
      <Menu
        id="long-menu"
        MenuListProps={{
          "aria-labelledby": "long-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            borderRadius: "5px",
          },
        }}
      >
        {options.map((option) => (
          <>
          {option.val==='New Version'&&<Divider/>}
          <MenuItem
            key={option.id}
            onClick={() => onClickOptions(option.id)}
            selected={option === "Pyxis"}
            // style={{ textAlign: "center", fontWeight: "200", fontSize: "14px" }}
            disabled={option.val==='New Version'?true:false}
          >
            <span style={{fontSize:'13px', fontWeight:'100'}}>{option.val}</span>
          </MenuItem>
          {option.val==='New Version'&&<Divider/>}
          </>
        ))}
      </Menu>
    </div>
  );
}
